export const DocSizeError: string = 'DocSizeError';
